import MsalAuthProvider from "./MsalAuthProvider";

export default MsalAuthProvider;